module.exports = __webpack_public_path__ + "img/skip-backward-fill.33e07a08.svg";